import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight, Sparkles, ShieldCheck, GraduationCap } from "lucide-react";

export default function Hero() {
  return (
    <section className="relative bg-white overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 bg-grid pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 pt-10 md:pt-16 pb-14 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-brand-line bg-white">
              <span className="w-1.5 h-1.5 bg-brand-cta rounded-full animate-pulse" />
              <span className="overline">Organisme certifié Qualiopi · CPF · OPCO</span>
            </div>
            <h1
              className="font-heading font-black tracking-tighter text-[2.6rem] sm:text-5xl lg:text-6xl xl:text-7xl leading-[1.02] mt-6 text-brand-ink hyphens-none"
              data-testid="hero-headline"
            >
              Formation <span className="text-brand-blue">Intelligence Artificielle</span> certifiante pour entreprises et salariés.
            </h1>
            <p className="mt-5 text-base md:text-lg lg:text-xl text-slate-600 leading-relaxed max-w-2xl">
              YAFORMIS est l'organisme spécialisé dans la formation à l'IA pour les professionnels : <strong className="text-brand-ink">initiation IA, outils IA, IA générative, agents IA</strong>. Quatre parcours certifiants éligibles <strong className="text-brand-ink">CPF et OPCO</strong>, dispensés par des formateurs praticiens, en présentiel ou distanciel.
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              <Link to="/contact" className="btn-cta" data-testid="hero-cta-primary">
                Demander un devis gratuit
                <ArrowUpRight className="w-5 h-5" />
              </Link>
              <Link to="/formations" className="btn-ghost" data-testid="hero-cta-secondary">
                Voir les 4 formations
                <ArrowRight className="w-5 h-5" />
              </Link>
            </div>

            <div className="mt-9 grid grid-cols-3 gap-4 max-w-xl">
              <div className="border-l-2 border-brand-blue pl-4">
                <div className="font-heading font-black text-3xl md:text-4xl text-brand-ink leading-none">200+</div>
                <div className="text-xs text-slate-500 mt-1.5">Stagiaires formés</div>
              </div>
              <div className="border-l-2 border-brand-blue pl-4">
                <div className="font-heading font-black text-3xl md:text-4xl text-brand-ink leading-none">96%</div>
                <div className="text-xs text-slate-500 mt-1.5">Taux de satisfaction</div>
              </div>
              <div className="border-l-2 border-brand-blue pl-4">
                <div className="font-heading font-black text-3xl md:text-4xl text-brand-ink leading-none">4.9<span className="text-brand-blue">/5</span></div>
                <div className="text-xs text-slate-500 mt-1.5">Note moyenne</div>
              </div>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-2 text-xs">
              <Badge icon={ShieldCheck} label="Qualiopi · CERTIFOPAC" />
              <Badge icon={GraduationCap} label="Éligible CPF" />
              <Badge icon={Sparkles} label="OPCO · Plan de dev." />
            </div>
          </div>

          <div className="lg:col-span-5 relative">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-brand-blue z-0" />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-2 border-brand-cta z-0" />
              <img
                src="/illustrations/hero-formation.png"
                alt="Stagiaires en formation professionnelle YAFORMIS"
                className="relative z-10 w-full aspect-[4/5] object-cover"
                data-testid="hero-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Badge({ icon: Icon, label }) {
  return (
    <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-brand-surface border border-brand-line">
      <Icon className="w-3.5 h-3.5 text-brand-blue" />
      <span className="font-bold text-brand-ink tracking-wide">{label}</span>
    </div>
  );
}
